// extracted by mini-css-extract-plugin
export default {"home":"Videos_SubScription_home__ZzUPa","home2":"Videos_SubScription_home2__SgL6b","main":"Videos_SubScription_main__MRiFY"};